import {
  CHANGE_VISIBLE,
  CHANGE_TITLE,
  CHANGE_TEXT
} from './actions'

export default function(state = {
  visible: false,
  title: '',
  text: ''
}, action) {
  switch(action.type) {
    case CHANGE_VISIBLE:
      return { ...state, visible: action.payload }
    case CHANGE_TITLE:
      return { ...state, title: action.payload }
    case CHANGE_TEXT:
      return { ...state, text: action.payload }
    default:
      return state
  }
}
